import { Component, OnChanges, Input } from '@angular/core';

@Component({
  selector: 'app-section-concepto',
  templateUrl: './section-concepto.component.html',
  styleUrls: ['./section-concepto.component.css']
})
export class SectionConceptoComponent implements OnChanges {

  @Input() public objetoSectionConcepto : SectionConcepto = {
    conclusionesOcupacionales : {
      nomb : "",
      nume : "",
      lab : "",
      serv : "",
      rest : ""
    },
    conductasOcupacionales : [],
    recomendaciones : [],
    conceptoMedico : ""
  }

  constructor() { }

  ngOnChanges() {
    this.getObjetoSectionConcepto();
  }

  public async getObjetoSectionConcepto() {
    try {
      await this.objetoSectionConcepto;
    } catch(exception) {
      console.log(exception);
    }
  }

}

interface SectionConcepto {
  conclusionesOcupacionales : ObjetoConclusiones,
  conductasOcupacionales : string[],
  recomendaciones : string[],
  conceptoMedico : string
}

interface ObjetoConclusiones {
  nomb : string,
  nume: string,
  rest : string,
  serv : string,
  lab : string
}